import { Component, HostBinding, HostListener, inject, input } from '@angular/core';
import { SvgIconComponent } from "../svg-icon/svg-icon.component";
import { NotifyService } from '../notify';
import { ClipboardService } from '../../core/service/clipboard.service';

@Component({
  selector: 'app-copy-button',
  imports: [SvgIconComponent],
  templateUrl: './copy-button.component.html',
  styleUrl: './copy-button.component.scss',
})
export class CopyButtonComponent {
  data = input.required<unknown>()
  title = input<string>('Скопировать')

  private clipboard = inject(ClipboardService)
  private notifyService = inject(NotifyService)

  @HostBinding('title')
  protected get titleAttr() {
    return this.title()
  }

  private copyData() {
    const data = this.data()
    this.clipboard.copyText(typeof data == 'string' || typeof data == 'number' ? String(data) : JSON.stringify(data, null, 2)).subscribe(() => {
      this.notifyService.createFromText('Скопировано')
    })
  }

  @HostListener('click', ['$event'])
  protected onClick(event: MouseEvent) {
    this.copyData()
    event.stopPropagation()
    event.preventDefault()
  }
}
